(function () {
    "use strict";

    function initializeGuide(root) {
        if (root.dataset.vlpGuideReady === "true") {
            return;
        }
        root.dataset.vlpGuideReady = "true";

        var search = root.querySelector("[data-vlp-search]");
        var clearSearch = root.querySelector("[data-vlp-search-clear]");
        var searchStatus = root.querySelector("[data-vlp-search-status]");
        var emptyState = root.querySelector("[data-vlp-empty-state]");
        var sectionLinks = Array.prototype.slice.call(root.querySelectorAll("[data-vlp-section-links]"));
        var navGroups = Array.prototype.slice.call(root.querySelectorAll("[data-vlp-nav-group]"));
        var navItems = Array.prototype.slice.call(root.querySelectorAll("[data-vlp-nav-item]"));
        var navLinks = Array.prototype.slice.call(root.querySelectorAll("[data-vlp-nav-link]"));
        var searchItems = Array.prototype.slice.call(root.querySelectorAll("[data-vlp-search-item]"));
        var sidebar = root.querySelector("[data-vlp-sidebar]");
        var mobileToggle = root.querySelector("[data-vlp-mobile-toggle]");
        var backdrop = root.querySelector("[data-vlp-backdrop]");
        var lightbox = root.querySelector("[data-vlp-lightbox]");
        var lightboxImage = root.querySelector("[data-vlp-lightbox-image]");
        var lightboxClose = root.querySelector("[data-vlp-lightbox-close]");
        var lastFocusedImage = null;

        function setActiveLink(id) {
            navLinks.forEach(function (link) {
                var isActive = link.getAttribute("href") === "#" + id;
                link.classList.toggle("is-active", isActive);
                if (isActive) {
                    link.setAttribute("aria-current", "location");
                } else {
                    link.removeAttribute("aria-current");
                }
            });
        }

        function closeMobileNavigation() {
            if (!sidebar || !mobileToggle || !backdrop) {
                return;
            }
            sidebar.classList.remove("is-open");
            backdrop.classList.remove("is-visible");
            mobileToggle.setAttribute("aria-expanded", "false");
            document.body.style.overflow = "";
        }

        function openMobileNavigation() {
            if (!sidebar || !mobileToggle || !backdrop) {
                return;
            }
            sidebar.classList.add("is-open");
            backdrop.classList.add("is-visible");
            mobileToggle.setAttribute("aria-expanded", "true");
            document.body.style.overflow = "hidden";
            if (search) {
                search.focus();
            }
        }

        function applySearch() {
            var query = search.value.trim().toLocaleLowerCase();
            var visibleNavCount = 0;
            var visibleSearchCount = 0;

            navItems.forEach(function (item) {
                var searchText = item.getAttribute("data-search") || "";
                var matches = !query || searchText.indexOf(query) !== -1;
                item.hidden = !matches;
                if (matches) {
                    visibleNavCount += 1;
                }
            });

            navGroups.forEach(function (group) {
                var groupItems = Array.prototype.slice.call(group.querySelectorAll("[data-vlp-nav-item]"));
                var hasVisibleItem = groupItems.some(function (item) {
                    return !item.hidden;
                });
                group.hidden = Boolean(query) && !hasVisibleItem;
                if (query && hasVisibleItem) {
                    group.open = true;
                }
            });

            searchItems.forEach(function (item) {
                var searchText = item.getAttribute("data-search") || "";
                var matches = !query || searchText.indexOf(query) !== -1;
                item.hidden = !matches;
                if (matches) {
                    visibleSearchCount += 1;
                }
            });

            root.querySelectorAll("[data-vlp-search-group]").forEach(function (group) {
                var groupItems = Array.prototype.slice.call(
                    group.querySelectorAll("[data-vlp-search-item]")
                );
                var hasVisibleItem = groupItems.some(function (item) {
                    return !item.hidden;
                });
                group.hidden = Boolean(query) && !hasVisibleItem;
            });

            clearSearch.classList.toggle("is-visible", query.length > 0);
            var visibleCount = searchItems.length ? visibleSearchCount : visibleNavCount;
            emptyState.classList.toggle("is-visible", Boolean(query) && visibleCount === 0);
            var statusLabel = searchStatus.getAttribute("data-status-label") || "result";
            searchStatus.textContent = query
                ? visibleCount + " matching " + statusLabel + (visibleCount === 1 ? "" : "s")
                : visibleCount + " " + statusLabel + (visibleCount === 1 ? "" : "s");

            sectionLinks.forEach(function (links) {
                if (query) {
                    links.hidden = false;
                }
            });
        }

        function openLightbox(image) {
            if (!lightbox || !lightboxImage || !lightboxClose) {
                return;
            }
            lastFocusedImage = image;
            lightboxImage.src = image.currentSrc || image.src;
            lightboxImage.alt = image.alt;
            lightboxImage.width = image.naturalWidth || Number(image.getAttribute("width")) || 1;
            lightboxImage.height = image.naturalHeight || Number(image.getAttribute("height")) || 1;
            lightbox.classList.add("is-open");
            lightbox.setAttribute("aria-hidden", "false");
            document.body.style.overflow = "hidden";
            lightboxClose.focus();
        }

        function closeLightbox() {
            if (!lightbox || !lightboxImage) {
                return;
            }
            lightbox.classList.remove("is-open");
            lightbox.setAttribute("aria-hidden", "true");
            lightboxImage.removeAttribute("src");
            document.body.style.overflow = "";
            if (lastFocusedImage) {
                lastFocusedImage.focus();
            }
        }

        search.addEventListener("input", applySearch);
        clearSearch.addEventListener("click", function () {
            search.value = "";
            applySearch();
            search.focus();
        });

        navLinks.forEach(function (link) {
            link.addEventListener("click", function () {
                var id = link.getAttribute("href").slice(1);
                setActiveLink(id);
                if (window.innerWidth <= 900) {
                    closeMobileNavigation();
                }
            });
        });

        if (mobileToggle && sidebar && backdrop) {
            mobileToggle.addEventListener("click", function () {
                if (sidebar.classList.contains("is-open")) {
                    closeMobileNavigation();
                } else {
                    openMobileNavigation();
                }
            });
            backdrop.addEventListener("click", closeMobileNavigation);
        }

        root.querySelectorAll(".vlp-guide-image img, .vlp-guide-gallery img").forEach(function (image) {
            image.tabIndex = 0;
            image.setAttribute("role", "button");
            image.setAttribute("aria-label", "Open larger image: " + image.alt);
            image.addEventListener("click", function () {
                openLightbox(image);
            });
            image.addEventListener("keydown", function (event) {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    openLightbox(image);
                }
            });
        });

        if (lightboxClose && lightbox) {
            lightboxClose.addEventListener("click", closeLightbox);
            lightbox.addEventListener("click", function (event) {
                if (event.target === lightbox) {
                    closeLightbox();
                }
            });
        }

        document.addEventListener("keydown", function (event) {
            if (event.key !== "Escape") {
                return;
            }
            if (lightbox && lightbox.classList.contains("is-open")) {
                closeLightbox();
            } else if (sidebar && mobileToggle && sidebar.classList.contains("is-open")) {
                closeMobileNavigation();
                mobileToggle.focus();
            }
        });

        if ("IntersectionObserver" in window) {
            var headings = Array.prototype.slice.call(root.querySelectorAll(".vlp-guide-article h2[id], .vlp-guide-article h3[id]"));
            var observer = new IntersectionObserver(function (entries) {
                var visible = entries.filter(function (entry) {
                    return entry.isIntersecting;
                });
                if (visible.length) {
                    visible.sort(function (left, right) {
                        return left.boundingClientRect.top - right.boundingClientRect.top;
                    });
                    setActiveLink(visible[0].target.id);
                }
            }, { rootMargin: "-10% 0px -78% 0px", threshold: [0, 1] });
            headings.forEach(function (heading) {
                observer.observe(heading);
            });
        }

        var initialId = window.location.hash.slice(1);
        if (initialId && root.querySelector("#" + CSS.escape(initialId))) {
            setActiveLink(initialId);
        } else if (navLinks.length) {
            setActiveLink(navLinks[0].getAttribute("href").slice(1));
        }
        applySearch();
    }

    function initializeAllGuides() {
        document.querySelectorAll("[data-vlp-guide]").forEach(initializeGuide);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initializeAllGuides);
    } else {
        initializeAllGuides();
    }

    document.addEventListener("shopify:section:load", function (event) {
        var root = event.target.querySelector("[data-vlp-guide]");
        if (root) {
            initializeGuide(root);
        }
    });
}());
